module.exports = __webpack_public_path__ + "static/media/SubmittedIcon.db482ecf.svg";